// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__1wPhE","expandIcon":"AccordionButton_expandIcon__AkXRb","expanded":"AccordionButton_expanded__Sdcjv"};